module.exports = __webpack_public_path__ + "media/chestnut_montage.bf85db84.mp4";